import { Button, Stack, Typography } from '@mui/material'
import { forwardRef } from 'react'
import {
  CheckboxButtonField,
  CheckboxButtonFieldProps,
  InformationModal,
} from 'utoniq-ui'

import { tLabel, useForm, UseFormProps, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

export type CommunityNoteModalProps = {
  open: boolean
  onSubmit: (values: FormProps) => Promise<void>
}

type FormProps = {
  accept: boolean
}

const schema: UseFormProps['schema'] = o => ({
  accept: o.boolean().optional().label(tLabel('threadCreate.accept')),
})

export const CommunityNoteModal: Cell<CommunityNoteModalProps> = ({
  open,
  onSubmit,
}) => {
  const { t } = useTranslation('threadCreate')
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm<FormProps>({
    schema,
    defaultValues: { accept: false },
  })

  return (
    <InformationModal
      open={open}
      onClose={() => {}}
      title={t('communityNoteTitle')}
      content={
        <Stack spacing={3}>
          <Typography variant="body2" align="left">
            {t('communityNoteDesc1')}
          </Typography>
          <Typography variant="caption" align="left">
            {t('communityNoteDesc2')}
          </Typography>
          <Stack sx={{ pb: 7, pt: 1 }}>
            <CheckboxButtonCell
              label={t('notDisplayNextTime')}
              error={errors?.accept}
              {...register('accept')}
            />
          </Stack>
        </Stack>
      }
      buttons={
        <Button
          sx={{ minWidth: 212 }}
          variant="contained"
          color="primary"
          size="large"
          loading={isSubmitting}
          disabled={isSubmitting}
          onClick={handleSubmit(onSubmit)}
        >
          {t('ok')}
        </Button>
      }
    />
  )
}

const CheckboxButtonCell = forwardRef<
  HTMLInputElement,
  Omit<CheckboxButtonFieldProps, 't'>
>((props, ref) => {
  const { t } = useTranslation('threadCreate')
  return (
    <CellFrame>
      <CheckboxButtonField {...props} ref={ref} t={t} />
    </CellFrame>
  )
})
